export const subscription = {
  title: "Subscription",
  description: "Manage your subscription and usage limits",
  currentPlan: "Current Plan",
  changePlan: "Change Plan",
  error: {
    loadFailed: "Failed to load subscription data"
  },
  status: {
    active: "Active",
    trial: "Trial",
    pending: "Pending",
    past_due: "Past Due",
    canceled: "Canceled",
    expired: "Expired",
    exhausted: "Exhausted"
  },
  billingCycle: {
    monthly: "per month",
    "semi-annual": "per 6 months",
    annualy: "per year",
    lifetime: "lifetime"
  },
  startDate: "Start Date",
  dueDate: "Due Date",
  trialEndDate: "Trial End Date",
  credits: {
    title: "Credits Usage",
    label: "Credits",
    remaining: "remaining",
    used: "Used",
    utilized: "utilized",
    unitCosts: "Credit Costs per Operation",
    showInNavbar: "Show in Navbar",
    hideInNavbar: "Hide from Navbar",
    exhausted: "Credits Exhausted",
    resourcesLimited: "Resources are now limited until credits are replenished",
    warning: "Credits Alert",
    limitWarning: "You have used {{percentage}}% of your credits. Consider upgrading."
  },
  consumption: {
    title: "Current Period Consumption",
    periodStart: "Period started on",
    agentExecutions: "Workflow Executions",
    playgroundChats: "Chats",
    embeddings: "Embeddings",
    workspaces: "Workspaces",
    // Generic translations for categories
    agents_executions: "Workflow Executions",
    playground_chats: "Chats",
    knowledge_base_embeddings: "Embeddings",
    products_workspaces: "Workspaces",
    // Fallbacks for individual metrics
    executions: "Executions",
    chats: "Chats"
  },
  fixedLimits: {
    title: "Plan Limits",
    description: "Fixed limits for your subscription plan",
    days: "days"
  },
  features: {
    title: "Plan Features"
  },
  restrictions: {
    title: "Plan Restrictions"
  },
  statusChanged: "Subscription Status Changed",
  sse: {
    connectionError: "Connection Error",
    connectionErrorDescription: "Could not connect to server for real-time updates. Please reload the page."
  }
} as const;
